import clsx from "clsx";

import { t } from "i18n/i18n";
import { AssessmentPublishStatusKey } from "i18n/i18next";
import { TooltipTrigger } from "mds/components/TooltipTrigger";
import { CircleCheckFilledIcon, LongFormPencilIcon } from "mds/icons";

const PUBLISH_STATUS_COLOR_MAP: Record<AssessmentPublishStatusKey, string> = {
  published: "text-green-shade-20",
  na: "text-black-tint-20",
  draft: "text-yellow-shade-20",
  error: "text-red-shade-20",
};

const PUBLISH_STATUS_ICON_MAP: Record<AssessmentPublishStatusKey, React.ReactNode | null> = {
  published: <CircleCheckFilledIcon className="text-green" size="xs" />,
  na: null,
  draft: <LongFormPencilIcon className={PUBLISH_STATUS_COLOR_MAP.draft} size="xs" />,
  error: null,
};

export const PublishStatus = ({ status }: { status: AssessmentPublishStatusKey }) => {
  const label = t(`assessment_dashboard.publish_status.${status}`);
  const tooltipText = t(`assessment_dashboard.publish_status_tooltips.${status}`);
  // TODO: If we every define a standardized color palette for status colors, we should
  // grab those instead of redefining them here and other places.
  const color = PUBLISH_STATUS_COLOR_MAP[status] || PUBLISH_STATUS_COLOR_MAP.error;
  const icon = PUBLISH_STATUS_ICON_MAP[status] || null;

  return (
    // fit-content is used to make sure the tooltip is positioned over the middle of the text
    <div className="w-fit">
      <TooltipTrigger content={tooltipText}>
        <div className="flex items-center gap-1">
          <span className={clsx("h6", color)}>{label}</span>
          {icon}
        </div>
      </TooltipTrigger>
    </div>
  );
};
